<template>
  <v-card>
    <v-list-item
        dark
        :class="mainApplicant ? 'indigo' : 'primary'"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-account
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ title }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click.prevent="$emit('remove')">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-card-text>
      <applicant-form
          ref="form"
          v-bind:value="details"
          v-on:input="$emit('input', details)"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import ApplicantForm from './Form'

export default {
  components: {
    ApplicantForm
  },
  name: 'ApplicantCard',
  props: {
    value: Object,
    mainApplicant: Boolean
  },
  data() {
    return {
      menu: false,
      details: this.value
    }
  },
  computed: {
    title() {
      if (this.mainApplicant) {
        return 'Main Applicant Details'
      }
      return 'Applicant Details'
    }
  },
  mounted() {
  },
  watch: {},
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>